import React, { forwardRef } from 'react';

import styles from './Heading.module.scss';

/**
 * Компонент заголовка для дашборда.
 * Технически аналогичен числовому блоку (Card), но отображает только пустой контейнер.
 * Заголовок отображается в родительском компоненте (Dashboards.tsx).
 */
const Heading = forwardRef((props: any, ref: any) => {
  // Компонент не отображает ничего — заголовок рендерится в родителе
  // Но технически это полноценный компонент, как и Card
  return (
    <div className={styles.headingContainer} ref={ref}>
      {/* Пустой контейнер — заголовок отображается в headerBlock родителя */}
    </div>
  );
});

export default Heading;
